export default "__VITE_ASSET__BRDAyOyO__"